'use es6';

import { logInteraction } from 'LayoutBuilderUI/actions/ApiActions';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
class InpageUsageTracker {
  track(event, properties) {
    logInteraction(properties);
  }
}
export const createUsageTrackerForSharedActions = () => {
  UsageTracker.init(new InpageUsageTracker(), 'logging');
};